// Bech32 (BIP173) / Bech32m (BIP350) Bitcoin address check, dependency-free.
// wallet-address-validator 0.1.x predates native SegWit and rejects every
// bc1/tb1 address, so this module covers them: witness v0 (P2WPKH 20 bytes,
// P2WSH 32 bytes, bech32) and v1+ (P2TR, bech32m). Accepted HRPs: bc
// (mainnet), tb (testnet/signet), bcrt (regtest); the backend enforces the
// configured network, the client only filters malformed input.

const CHARSET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'
const BECH32_CONST = 1
const BECH32M_CONST = 0x2bc830a3
const HRPS = ['bc', 'tb', 'bcrt']

function polymod (values) {
  const GEN = [0x3b6a57b2, 0x26508e6d, 0x1ea119fa, 0x3d4233dd, 0x2a1462b3]
  let chk = 1
  for (const v of values) {
    const top = chk >>> 25
    chk = ((chk & 0x1ffffff) << 5) ^ v
    for (let i = 0; i < 5; i++) {
      if ((top >>> i) & 1) chk ^= GEN[i]
    }
  }
  return chk >>> 0
}

function hrpExpand (hrp) {
  const out = []
  for (const c of hrp) out.push(c.charCodeAt(0) >>> 5)
  out.push(0)
  for (const c of hrp) out.push(c.charCodeAt(0) & 31)
  return out
}

function convertBits (data, from, to) {
  let acc = 0
  let bits = 0
  const out = []
  const maxv = (1 << to) - 1
  for (const value of data) {
    acc = (acc << from) | value
    bits += from
    while (bits >= to) {
      bits -= to
      out.push((acc >>> bits) & maxv)
    }
  }
  if (bits >= from || ((acc << (to - bits)) & maxv)) return null
  return out
}

/**
 * @param {string} address
 * @returns {boolean} true for a well-formed native SegWit / Taproot address
 */
export function isBech32BitcoinAddress (address) {
  if (typeof address !== 'string' || address.length < 14 || address.length > 90) return false
  // BIP173: all lower-case or all upper-case, never mixed
  const lower = address.toLowerCase()
  if (address !== lower && address !== address.toUpperCase()) return false

  const sep = lower.lastIndexOf('1')
  if (sep < 1 || sep + 7 > lower.length) return false
  const hrp = lower.slice(0, sep)
  if (!HRPS.includes(hrp)) return false

  const data = []
  for (const c of lower.slice(sep + 1)) {
    const v = CHARSET.indexOf(c)
    if (v === -1) return false
    data.push(v)
  }

  const checksum = polymod(hrpExpand(hrp).concat(data))
  const version = data[0]
  if (version > 16) return false
  const expected = version === 0 ? BECH32_CONST : BECH32M_CONST
  if (checksum !== expected) return false

  const program = convertBits(data.slice(1, -6), 5, 8)
  if (!program || program.length < 2 || program.length > 40) return false
  if (version === 0 && program.length !== 20 && program.length !== 32) return false
  return true
}



// WEBPACK FOOTER //
// ./src/validator/bech32_btc.js